export const MOBILE_PATHS = {
  root: "/",
  donor: (id: string) => `/?id=${id}`,
  contactLog: (id: string) => `/mobile/log/${id}`,
  action: (id: string) => `/mobile/actions/${id}`,
} as const;
